/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MASQUERADER_LIST = gql`
  query Content(
    $filter: UserAdvancedSearchFilterInput
    $options: GetManyOptions
  ) {
    getUserAdvancedSearch(filter: $filter, options: $options) {
      count
      limit
      skip
      content {
        _id
        id
        Referal {
          partition
        }
        User {
          _id
          vuid
          email
          fullName
          gender
          address {
            addressLine1
            addressLine2
            city
            state
            zipcode
            country
          }
        }
        totalAmount
        paymentStats
        boxStatus
        costumeID
        createdAt
        Section {
          name
          _id
        }
        CostumeType {
          _id
          name
        }
        note
      }
    }
  }
`;

export const GET_MASQUERADER_LIST_ADMIN = gql`
  query Content(
    $filter: UserAdvancedSearchFilterInput
    $options: GetManyOptions
  ) {
    getUserAdvancedSearch(filter: $filter, options: $options) {
      count
      limit
      skip
      content {
        _id
        id
        Referal {
          partition
        }
        User {
          _id
          vuid
          email
          fullName
          gender
          address {
            addressLine1
            addressLine2
            city
            state
            zipcode
            country
          }
        }
        totalAmount
        paymentStats
        boxStatus
        costumeID
        createdAt
        ReferalUsers {
          email
          fullName
          gender
        }
        Section {
          name
          _id
        }
        CostumeType {
          _id
          name
        }
        note
      }
    }
  }
`;
